module.exports = __webpack_public_path__ + "resources/img/solution_commerce_rescue2_m2.fa5ef2dac529ced9056e62fb6a5f8e0b.png";